const TDTourPlayIcon = ({ viewBox = "0 0 32 32", className = "hayley-h-8 hayley-w-8 hayley-text-secondary" }) => {
  return (
    <svg data-testid="3d-tour-play-icon" viewBox={viewBox} fill="none" className={className}>
      <path
        d="M15.3939 10.7226C15.703 10.7067 16.0158 10.6973 16.3333 10.6973C22.0402 10.6973 26.6667 13.2205 26.6667 16.3336C26.6667 19.4468 22.0402 21.97 16.3333 21.97C10.6265 21.97 6 19.4468 6 16.3336C6.04341 15.6874 6.23557 15.0599 6.56147 14.5002C6.88737 13.9404 7.3382 13.4636 7.87879 13.1068"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M21.9443 17.2727C21.9603 16.9637 21.9697 16.6508 21.9697 16.3333C21.9697 10.6265 19.4465 6 16.3333 6C13.2202 6 10.697 10.6265 10.697 16.3333C10.697 22.0402 13.2202 26.6667 16.3333 26.6667C16.9796 26.6233 17.607 26.4311 18.1668 26.1052C18.7265 25.7793 19.2034 25.3285 19.5602 24.7879"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M16.3333 17.2723C16.8521 17.2723 17.2727 16.8518 17.2727 16.3329C17.2727 15.8141 16.8521 15.3936 16.3333 15.3936C15.8145 15.3936 15.3939 15.8141 15.3939 16.3329C15.3939 16.8518 15.8145 17.2723 16.3333 17.2723Z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
};

export default TDTourPlayIcon;
